import { Box } from "@ecco/ui/box";
import { customCursor } from "@ecco/ui/ecco-cursor";
import { memo } from "react";
import type { ProductMedia } from "@lib/product/types";
import plus from "@ecco/ui/icons/plus.svg";
import { ProductImageFrame } from "@ecco/ui/product-image-frame";

type ProductImageProps = {
    media: ProductMedia;
    onImageClick: (index: number) => void;
    currentlySelected: boolean;
    index: number;
    priority: boolean;
    alt: string;
};

export const ProductImage = memo(
    ({ media, onImageClick, currentlySelected, priority, alt, index }: ProductImageProps) => {
        return (
            <Box
                cursor={customCursor(plus)}
                onClickCapture={() => onImageClick(index)}
                aspectRatio={"4/5"}
                position="absolute"
                top={0}
                w="100%"
                left={0}
                opacity={currentlySelected ? 1 : 0}
                transitionProperty="common"
                transitionDuration="slow"
                zIndex={currentlySelected ? 1 : 0}
            >
                <ProductImageFrame
                    sizes={[
                        "100vw", // mobile: full width, stacked layout
                        "100vw", // large mobile: full width
                        "50vw", // tablet: left column ~50%
                        "50vw", // desktop: left column ~50%
                    ]}
                    src={media.url}
                    priority={priority}
                    alt={alt}
                    objectFit="scale-down"
                />
            </Box>
        );
    }
);

ProductImage.displayName = "ProductImage";

export default ProductImage;
